window.UUID = UUID = () => {
    var d = new Date().getTime();
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

window.refreshCartAttributes = refreshCartAttributes = async (setLastLoginTime = false) => {
    console.log(`In Refresh Attributes... Customer ID >>`,window.customer?.id)
    return new Promise(async (resolve, reject) => {
        const stroetmannCart = await fetch('/cart?view=json');
        const { current_user, current_date, current_user_alias, current_username } = await stroetmannCart.json();
        const formData = new FormData();
        if (!current_user) {
            formData.append('attributes[login_refresh]', 'false');
            formData.append('attributes[username_key]', '');
            formData.append('attributes[current_date]', '');
            formData.append('attributes[current_user]', '');
            formData.append('attributes[current_user_alias]', '');
            formData.append('attributes[bonus_amount]', '');
            formData.append('attributes[bonus_amount_max]', '');
            try {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Bypass-Internal': 'true',
                        'No-Queue': 'true'
                    },
                    body: formData,
                });
            } catch (error) {
                console.error('Error clearing cart attributes before logout:', error);
            }
            window.alert(`Validierung nicht möglich. Bitte versuchen Sie es erneut...`);
            window.location.href = 'https://login.stroetmann24.com/auth/logout?return_to=/';
            return;
        }
        formData.append('attributes[current_date]', current_date);
        formData.append('attributes[current_user]', current_user);
        formData.append('attributes[login_refresh]', 'false');
        if(current_user_alias) formData.append('attributes[current_user_alias]', current_user_alias);
        try {
            const updateResponse = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Bypass-Internal': 'true',
                    'No-Queue': 'true'
                },
                body: formData,
            });

            if(!updateResponse.ok){
                console.error('Cart update failed:', updateResponse.status);
                const errorText = await updateResponse.text();
                console.error('Error details:', errorText);
                
                // Still resolve to prevent blocking the rebuild process
                // The cart might still be functional even if attribute update fails
                resolve();
                return;
            }

            if(setLastLoginTime){
                await setLastLoginUserTimestamp(current_username);
            }
        } catch (error) {
            console.error('Error updating cart attributes:', error);
            // Still resolve to prevent blocking the rebuild process
            resolve();
            return;
        }
        resolve();
    });
}

window.clearDiscounts = clearDiscounts = async () => {
    const request = await fetch(`${window.theme.routes.cart}.js`, {
        headers: {
            'Content-Type': 'application/json',
            'Bypass-Internal': 'true',
            'No-Queue': 'true'
        }
    });
    const cart = await request.json();
    const token = document.querySelector('body').dataset.token;
    const query = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                    cart {
                        id
                        discountCodes {
                            code
                        }
                    }
                    userErrors {
                        field
                        message
                    }
                    warnings {
                        code
                        message
                    }
                }
            }`;
    const variables = {
        "cartId": `gid://shopify/Cart/${cart.token}`,
        "discountCodes": []
    };
    return fetch('/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Bypass-Internal': 'true',
            'No-Queue': 'true',
            'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: variables })
    });
}

// Global helper function to generate cart headers with customer ID
window.getCartHeaders = function(additionalHeaders = {}) {
    const headers = {
        'Content-Type': 'application/json',
        ...additionalHeaders
    };
    
    // Add customer ID header if customer is logged in
    if (window.customer && window.customer.id) {
        headers['X-Custom-Customer-ID'] = window.customer.id.toString();
    }

    if (window.customer && window.customer.userName) {
        headers['X-Custom-User-Name'] = window.customer.userName.toString();
    }

    if (window.customer && window.customer.currentUserNumber) {
        headers['X-Custom-User-Number'] = window.customer.currentUserNumber.toString();
    }
    
    return headers;
};

window.clearCartAtributes = clearCartAtributes = async (clearUser = false) => {
    localStorage.removeItem('checkout_update_at');
    localStorage.removeItem('related_products');
    localStorage.removeItem('checkout_timeout');
    localStorage.removeItem('checkout_update_checkout_timeout');
    localStorage.removeItem('checkout_progress');
    localStorage.removeItem('checkout_approved');
    localStorage.removeItem('username_key');
    localStorage.removeItem('checkoutId');
    localStorage.removeItem('checkout');
    if (window.customer && window.customer.currentUserNumber) {
        localStorage.removeItem(`${window.customer.currentUserNumber}_bonus_response`);
        localStorage.removeItem(`${window.customer.currentUserNumber}_bonus_balance`);
    }
    
    // DO NOT clear the entire cart - only clear attributes and user identification in note
    const formData = new FormData();
    formData.append('attributes[locked]', '');
    formData.append('attributes[bonus_amount]', '');
    formData.append('attributes[bonus_amount_max]', '');
    
    if (clearUser) {
        // Clear user identification from note field while preserving actual user note

        // try {
        //     // Get current cart to extract actual user note
        //     const cartResponse = await fetch('/cart.js');
        //     const currentCart = await cartResponse.json();
            
        //     let preservedNote = '';
        //     if (currentCart.note) {
        //         const noteParts = currentCart.note.split('|');
        //         // If note contains our pipe-separated format, preserve only the actual note part
        //         if (noteParts.length > 3) {
        //             preservedNote = noteParts.slice(3).join('|');
        //         } else if (!currentCart.note.includes('|') || noteParts.length < 3) {
        //             // If note doesn't contain our format, preserve the entire note
        //             preservedNote = currentCart.note;
        //         }
        //     }
            
        //     // Set the preserved note (without user identification)
        //     formData.append('note', preservedNote);
        // } catch (error) {
        //     console.warn('Could not preserve user note during cart attributes clearing:', error);
        //     formData.append('note', ''); // Clear note entirely if we can't parse it
        // }

        // Clear note entirely
        formData.append('note', ''); 
        
        // Clear user-related attributes
        formData.append('attributes[current_date]', '');
        formData.append('attributes[username_key]', '');
        formData.append('attributes[current_user]', '');
        formData.append('attributes[current_user_alias]', '');
    }
    // If clearUser is false, don't modify the note field at all
    
    const headers = window.getCartHeaders({
        'Bypass-Internal': 'true',
        'No-Queue': 'true',
    });
    
    try {
        const response = await fetch(`${window.theme.routes.cartUpdate}.js`, {
            method: 'POST',
            headers: headers,
            body: formData,
        });
        
        if (!response.ok) {
            console.warn(`Cart attributes clear returned ${response.status}, but continuing...`);
            // Don't throw error - cart might still be functional
        }
        
        return response;
    } catch (error) {
        console.warn('Cart attributes clear failed, but continuing:', error);
        // Return a mock successful response to prevent blocking
        return { ok: true, json: async () => ({}) };
    }
}

window.render = render = async () => {
    if (window.location.pathname.includes(`/cart`)) {
        return window.checkout.render();
    }
    return new Promise(async (resolve, reject) => {
        const cartItemSectionId = document.getElementById('cart-items')?.dataset.section || null;
        
        const sections = [];
        if (cartItemSectionId) {
            sections.push(cartItemSectionId);
        }
        if(!sections.length){
            return resolve();
        }
        const addResponse = await fetch(`/cart?sections=${sections.join(',')}&sections_url=${window.location.pathname}`);
        const addResponseJson = await addResponse.json();

        const mainCartTemplate = document.createElement('template');
        mainCartTemplate.innerHTML = addResponseJson[cartItemSectionId];;
        const mainCartEl = mainCartTemplate.content.querySelector(`#shopify-section-${cartItemSectionId}`);
        document.querySelector('.cc-main-cart').innerHTML = mainCartEl.innerHTML;

        return resolve();
    });
}

window.queueActive = queueActive = () => {
    return window.fetchQueue ? window.fetchQueue.running : false;
}

async function updateUserLoginKey(){
    let tokenRes;
    tokenRes = await fetch('https://login.stroetmann24.com/api/token', { credentials: 'include' });
    if (!tokenRes.ok || !tokenRes){
        const formData = new FormData();
        const email = window.customer?.email;
        formData.append('email', email);
        tokenRes = await fetch('/apps/stroetmann/api/v1/customers/get_login_key', {
            method: 'POST',
            body: formData,
        });
    }

    if (!tokenRes.ok || !tokenRes) return false;

    const data = await tokenRes.json();

    //KEY NOT FOUND
    if (!data?.key) return false;

    const key = data.key;
    const formData = new FormData();
    formData.append('attributes[username_key]', key);
    formData.append('attributes[login_refresh]', 'true');

    //Update cart
    const cartRes = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
    });

    if (!cartRes.ok) {
        throw new Error('Error updating cart');
        return false;
    }

    return true;
}

async function setLastLoginUserTimestamp(userName) {
    // console.log(`userName >>`,userName);
    if(!userName) return;

    const response = await fetch('/apps/stroetmann/api/v1/customers/set_last_login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userName })
    });

    if (!response.ok){
        console.error(`HTTP ${response.status}`);
        return false;
    };
}


document.addEventListener('DOMContentLoaded', async () => {
    
    // Clear reload blocks on successful page load (after a successful session)
    const timeSinceLastReload = Date.now() - parseInt(sessionStorage.getItem('last_page_load_time') || '0');
    if (timeSinceLastReload > 30000) { // 30 seconds since last reload attempt
        sessionStorage.removeItem('user_number_reload_blocked');
        sessionStorage.removeItem('user_number_reload_count');
    }
    sessionStorage.setItem('last_page_load_time', Date.now().toString());

    await new Promise((resolve) => { setTimeout(() => { resolve() }, 500); });

    if (window.queueActive()) {
        return;
    }

    const isTempUser = window.customer?.currentUserNumber?.startsWith('b2b_');
    const locked = document.querySelector('body').dataset.cartLocked == 'true';
    const checkoutPresent = document.querySelector('body').dataset.checkoutPresent == 'true';
    const hasCurrentUser = document.querySelector('body').dataset.hasCurrentUser == 'true';
    const hasCurrentDate = document.querySelector('body').dataset.hasCurrentDate == 'true';
    const userNumberPresent = document.querySelector('body').dataset.userNumberPresent == 'true';
    const cartItemLength = parseInt(document.querySelector('body').dataset.cartItemLength);
    const hasUsernameKey = document.querySelector('body').dataset.usernameKeyPresent == 'true';

    if (window.customer == null && hasCurrentUser) {
        console.log(`🔄 LOGOUT ATTRIBUTE UPDATES ========`);
        window.clearCartAtributes(true);
        return;
    }

    if(window.customer && !hasUsernameKey){
        console.log(`🔄 LOGIN ATTRIBUTE UPDATES ========`);
        const loginVerifyModal = document.getElementById('loginVerifyModal');
        try {
            if(loginVerifyModal) loginVerifyModal.setAttribute(`open`,``);
            const result = await updateUserLoginKey();
            if(result){
                await window.refreshCartAttributes(true);
                window.location.reload();
                return;
            } else {
                if(loginVerifyModal) loginVerifyModal.querySelector(`.verification-txt`).textContent = `Validierung nicht möglich. Bitte versuchen Sie es erneut...`;
                window.location.href = 'https://login.stroetmann24.com/auth/logout?return_to=/';
                return;
            }
        } catch (error) {
            console.warn('Cart attributes refresh failed', error);
            if(loginVerifyModal) loginVerifyModal.querySelector(`.verification-txt`).textContent = `Validierung nicht möglich. Bitte versuchen Sie es erneut...`;
            window.location.href = 'https://login.stroetmann24.com/auth/logout?return_to=/';
            return;
        }
    }


    if (window.customer !== null && !userNumberPresent) {
        console.log(`User Number Not Present ===`);
        // Prevent endless reloading with safety check
        const reloadCount = parseInt(sessionStorage.getItem('user_number_reload_count') || '0');
        if (reloadCount >= 3) {
            console.error('🚨 Too many user number reloads, stopping to prevent infinite loop');
            sessionStorage.setItem('user_number_reload_blocked', 'true');
            return;
        }
        
        if (sessionStorage.getItem('user_number_reload_blocked') === 'true') {
            console.log('🔄 User number reload blocked due to previous failures');
            return;
        }
        
        sessionStorage.setItem('user_number_reload_count', (reloadCount + 1).toString());
        
        document.getElementById('cart-icon-bubble').classList.add('loading');
        document.querySelector('.cart-icon-bubble-loading').classList.remove('hidden');
        await window.refreshCartAttributes();
        window.location.reload();
        return;
    }

    if (!hasCurrentDate) {
        if (window.location.pathname != '/pages/thank-you' && cartItemLength) {
            document.dispatchEvent(new CustomEvent('main-calendar:on:open', { bubbles: true }));
        }
        return;
    }
});